import PropTypes from 'prop-types';
import { trans, getPagePath, useSoyuzLocales } from '@spotahome/soyuz/client';

import Button from '../../Button';
import GoogleIcon from '../../icons/GoogleIcon';
import FacebookRoundIcon from '../../icons/FacebookRoundIcon';

import styles from './LoginSignupModalSocial.module.scss';

const SOCIAL_NETWORKS = {
  google: {
    renderIcon: () => <GoogleIcon theme="dark" />
  },
  facebook: {
    renderIcon: () => <FacebookRoundIcon />
  }
};

const LoginSignupModalSocialButton = ({ social, redirectUrl }) => {
  const socialConfig = SOCIAL_NETWORKS[social];
  const { current } = useSoyuzLocales();

  const handleSocialButtonClick = () => {
    const newUrl = new URL(
      getPagePath('show-login', {
        params: { authMethod: social },
        query: {
          locale: current,
          subscribe: 'no'
        }
      }),
      document.location
    );

    if (redirectUrl) {
      newUrl.searchParams.set('redirectUrl', redirectUrl);
    }

    window.location.href = newUrl;
  };

  if (!socialConfig) {
    return null;
  }

  return (
    <Button
      onClick={handleSocialButtonClick}
      className={`${styles['login-signup-modal-social__button']} ga-signup-${social}`}
    >
      {socialConfig.renderIcon()}
      <span>{trans(`loginsignup.modal.${social}`)}</span>
    </Button>
  );
};

LoginSignupModalSocialButton.propTypes = {
  social: PropTypes.oneOf(Object.keys(SOCIAL_NETWORKS)).isRequired,
  redirectUrl: PropTypes.string.isRequired
};

const LoginSignupModalSocial = ({
  redirectUrl,
  hideGoogleOauth,
  hideFacebookOauth
}) => (
  <div className={styles['login-signup-modal-social']}>
    {hideGoogleOauth ? null : (
      <LoginSignupModalSocialButton social="google" redirectUrl={redirectUrl} />
    )}
    {hideFacebookOauth ? null : (
      <LoginSignupModalSocialButton
        social="facebook"
        redirectUrl={redirectUrl}
      />
    )}
  </div>
);

LoginSignupModalSocial.propTypes = {
  redirectUrl: PropTypes.string.isRequired,
  hideGoogleOauth: PropTypes.bool.isRequired,
  hideFacebookOauth: PropTypes.bool.isRequired
};

export default LoginSignupModalSocial;
